import React from 'react';
import PropTypes from 'prop-types';
import CloseModalSvg from './CloseModalSvg';
import FacebookIcon from '../../Icons/Facebook';
import TwitterIcon from '../../Icons/Twitter';
import './Modal.sass';

const OutOfRangeModal = ({ onRequestHide, onToggleDeliveryModal }) => (
  <div className="home-modal not-in-range">
    <div className="home-modal-inner">
      <div className="close" onClick={onRequestHide}>
        <CloseModalSvg/>
      </div>
      <div className="home-modal-content">
        <h1>BUMMER! <span role="img" aria-label="sad">😞</span></h1>
        <p>
          We’re not in your area yet.
          Sign up and follow us as we continue expanding our revolution.
        </p>
        <div className="sign-up-form"></div>
        <div className="social">
          <a href="https://twitter.com/clustertruck">
            <TwitterIcon />
          </a>
          <a href="https://facebook.com/clustertruck">
            <FacebookIcon />
          </a>
        </div>
        <hr />
        <div className="delivery-info" onClick={onToggleDeliveryModal}>
          <span className="hide-mobile">You can also&nbsp;</span>check out our <u>current delivery locations.</u>
        </div>
      </div>
    </div>
  </div>
);

OutOfRangeModal.propTypes = {
  onRequestHide: PropTypes.func.isRequired,
  onToggleDeliveryModal: PropTypes.func.isRequired,
};

export default OutOfRangeModal;
